var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.055 11.437c-1.205.543-2.599.963-4.055.963a9.375 9.375 0 0 1-4.097-.958C3.79 12.062 2.5 13.798 2.5 15.55v1.8h15v-1.8c0-1.726-1.396-3.488-3.445-4.113ZM13.9 9.85c-1.2.6-2.55 1.05-3.9 1.05-1.5 0-2.85-.45-3.9-1.05-3 .6-5.1 3-5.1 5.7v3.3h18v-3.3c0-2.7-2.25-5.1-5.1-5.7ZM10 7.5c1.406 0 2.5-1.162 2.5-2.5 0-1.305-1.195-2.5-2.5-2.5-1.338 0-2.5 1.094-2.5 2.5S8.662 7.5 10 7.5ZM14 5c0 2.133-1.733 4-4 4-2.133 0-4-1.733-4-4s1.867-4 4-4 4 1.867 4 4Z",
    fill: "currentColor"
  })));
};
export default SvgProfile;